import { API_BASE_URL } from '../config/api';

export interface ClientRelationship {
  id: string;
  clientId: string;
  clientName: string;
  clientEmail: string;
  dietitianId: string;
  dietitianName: string;
  dietitianEmail: string;
  status: 'Active' | 'PendingDisconnection' | 'Disconnected';
  createdAt: string;
  updatedAt?: string;
  disconnectedAt?: string;
  disconnectionReason?: string;
  disconnectionRequestedBy?: 'Client' | 'Dietitian';
}

export const clientRelationshipApi = {
  async getRelationshipByClient(clientId: string): Promise<ClientRelationship | null> {
    const response = await fetch(
      `${API_BASE_URL}/clientrelationships/client/${clientId}`
    );
    if (!response.ok) {
      if (response.status === 404) {
        return null;
      }
      throw new Error('İlişki getirilemedi');
    }
    return await response.json();
  },

  async getRelationshipsByDietitian(dietitianId: string): Promise<ClientRelationship[]> {
    const response = await fetch(
      `${API_BASE_URL}/clientrelationships/dietitian/${dietitianId}`
    );
    if (!response.ok) {
      throw new Error('İlişkiler getirilemedi');
    }
    return await response.json();
  },

  async getRelationship(dietitianId: string, clientId: string): Promise<ClientRelationship | null> {
    const response = await fetch(
      `${API_BASE_URL}/clientrelationships/dietitian/${dietitianId}/client/${clientId}`
    );
    if (!response.ok) {
      if (response.status === 404) {
        return null;
      }
      throw new Error('İlişki getirilemedi');
    }
    return await response.json();
  },
};

